import React from 'reactn';
import { useQuery } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import { AmplifyModelContext } from 'amplify-model-react';
import get from 'lodash/get';

export default function useMyPpr({ periodId, memberId, skip }) {
  const { getModelSchema } = React.useContext(AmplifyModelContext);

  const query = React.useMemo(() => {
    const { basicFieldsString } = getModelSchema('PeriodPlanResult');
    return gql`
    query($memberId: ID!, $periodId: ID!) {
      searchPeriodPlanResults(
        filter: {
          periodPlanResultMemberId: { eq: $memberId }
          periodPlanResultPeriodId: { eq: $periodId }
        }
        sort: { field: createdAt, direction: desc }
        limit: 1
      ) {
        items {
          ${basicFieldsString}
        }
      }
    }
  `;
  }, [getModelSchema]);

  const { data: searchData, loading } = useQuery(query, {
    fetchPolicy: 'network-only',
    skip: !periodId || !memberId || skip,
    variables: {
      memberId,
      periodId,
    },
  });

  const data = React.useMemo(() => {
    return get(searchData, 'searchPeriodPlanResults.items.0');
  }, [searchData]);

  return { data, loading };
}
